import { useState, useEffect } from "react"
import { env } from "./environments/environment"
import { useSearchParams } from "react-router-dom"
import { PercentageBar } from "./components/UI/PercentageBar/Percentagebar"
import ModalDetail from "./components/UI/Card/ModalDetail"

export const QueryProcedure = () => {
	return <iframe title="consulta" src={env.query_proc_url} className="w-full h-[81vh]" />
}

export const QueryProcedureInner = () => {
	const [userid, setuserid] = useState("")
	const [working, set_working] = useState(false)
	const [data, set_data] = useState<any>()
	const [showModal, setShowModal] = useState(false)
	const [selectedExpediente, setSelectedExpediente] = useState("")

	const [searchParams] = useSearchParams()

	useEffect(() => {
		const userId = searchParams.get("user_id")
		if (userId) {
			setuserid(userId)
		}
	}, [searchParams])

	useEffect(() => {
		localStorage.setItem("user_id", userid)
	}, [userid])

	useEffect(() => {
		async function fetchData() {
			try {
				set_working(true)
				if (userid !== null) {
					const data = await fetch(`/api/query?id=${userid}`).then((res) => res.json())
					if (data !== null) {
						set_data(data)
					}
				}
			} finally {
				set_working(false)
			}
		}
		fetchData()
	}, [userid])

	const closeModal = () => {
		setShowModal(false)
		setSelectedExpediente("")
	}

	return (
		<section className="w-max mx-auto fixed">
			<h3 className="text-center" style={{ marginTop: 10 }}>
				Mis trámites
			</h3>
			{data === null ? (
				<div className="text-center mt-8 text-xl text-red-500">
					No tienes solicitudes abiertas.
				</div>
			) : data && data.length > 0 ? (
				<>
					<table className="tabletConsulta">
						<thead>
							<tr>
								<th className="bg-blue-800 text-white px-5 py-1">Fecha</th>
								<th className="bg-blue-800 text-white px-5 py-1">Expediente</th>
								<th className="bg-blue-800 text-white px-5 py-1">Nombre proyecto</th>
								<th className="bg-blue-800 text-white px-5 py-1">Estado</th>
								<th className="bg-blue-800 text-white px-5 py-1">Avance</th>
							</tr>
						</thead>
						<tbody>
							{data.map((item: any, index: any) => (
								<tr key={index}>
									<td className="px-5 py-1 whitespace-pre-wrap border-b border-l border-r">
										{item?.fecha}
									</td>
									<td className="px-5 py-1 whitespace-pre-wrap border-b border-l border-r">
										<button
											className="exp-btn"
											onClick={() => {
												setShowModal(true)
												setSelectedExpediente(item?.expediente)
											}}
										>
											{item?.expediente}
										</button>
									</td>
									<td className="px-5 py-1 whitespace-pre-wrap border-b border-l border-r">
										{item?.nombre}
									</td>
									<td className="px-5 py-1 whitespace-pre-wrap border-b border-l border-r">
										{item?.estado}
									</td>
									<td className="px-5 py-1 whitespace-pre-wrap border-b border-l border-r">
										<PercentageBar data={{ estado: item?.estado }} />
									</td>
								</tr>
							))}
						</tbody>
					</table>
					{showModal && (
						<ModalDetail show={showModal} closeModal={closeModal} expediente={selectedExpediente} />
					)}
				</>
			) : (
				<div className="text-center mt-8 text-xl text-red-500">
					No tienes solicitudes abiertas.
				</div>
			)}
		</section>
	)
}
